const setGraphData_absorption = payload => {
  return {
    type: "setGraphData_absorption",
    payload
  };
};
export default setGraphData_absorption;
